// extracted by mini-css-extract-plugin
module.exports = {"ability-level-gradient":"ability-grade_ability-level-gradient__obFbJ","ability-level-gradient-mobile":"ability-grade_ability-level-gradient-mobile__xbW2r"};